import classes from './modal.module.css'

const Modal = {
  classNames: {
    content: classes.content,
    header: classes.header,
    overlay: classes.overlay,
  },
}

export default Modal
